/* Resource Portal
  -> entry point
*/
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Root } from './Root';

let initProps;
let hmrRoot;
function ResourcePortalRoot(props) {
  initProps = props;
  return <Root {...props} />;
}

// Hot reloading
if (module.hot) {
  module.hot.accept('./Root', () => {
    const NextRoot = require('./Root').Root;
    if (!hmrRoot) {
      hmrRoot = createRoot(document.getElementById('react-root'));
    }
    hmrRoot.render(<NextRoot {...initProps} />);
  });
}

export default ResourcePortalRoot;
